import { Components, Theme } from "@mui/material/styles"

export const MuiIconButton: Components<Theme>["MuiIconButton"] = {
  styleOverrides: {
    root: {
      borderRadius: 10,
      fontFamily: "inherit",
    },
  },
}
